import React from 'react'
import CalendarUnavailableSvg from 'images/modules/Manage/i-calendar-unavailable.svg?raw'

export { default as CalendarUnavailableUrl } from 'images/modules/Manage/i-calendar-unavailable.svg'

export default props => (
  <span {...props} dangerouslySetInnerHTML={{__html: CalendarUnavailableSvg}} />
)
